import { ReactNode } from "react";
import { Card, CardContent, CardFooter } from "@/components/ui/Card";

type ItemCardProps = {
  content: ReactNode;
  footer?: ReactNode;
  className?: string;
};

/**
 * Generic card component that can be used for displaying various types of items
 * The component provides a consistent look and feel across different features
 */
const ItemCard: React.FC<ItemCardProps> = ({
  content,
  footer,
  className = "",
}) => {
  return (
    <Card className={`bg-backgroundcolor rounded-xl ${className}`}>
      <CardContent className="p-6">{content}</CardContent>
      {footer && <CardFooter>{footer}</CardFooter>}
    </Card>
  );
};

export default ItemCard;
